/* eslint-disable jsx-a11y/alt-text */
import React from 'react';
import { observer } from 'mobx-react';

import styles from './widgets.module.css';
import dashboardStore from '../../../stores/dashboard.store';
import memberStore from '../../../stores/member.store';
import { statUnitLabel } from '../../../models/stat.model';

import blackFlag from '../../../img/logs/black-flag.svg';
import wheel from '../../../img/logs/wheel.svg';
import buoy from '../../../img/logs/buoy.svg';

interface PercentageProps {
  title: string;
  src: string;
  percentage: number;
  color: string;
}

const Percentage = ({title, src, percentage, color}: PercentageProps) => {
  const percWidth = 170 * percentage;
  return (
    <div className={styles.percentage}>
      <div className={styles.percentageTitle}> {title} </div>
      <div className={styles.percentageCenter}>
        <img src={src} className={styles.percentageImage} />
        <div className={styles.percentageText} style={{color}}> {Math.floor(percentage * 1000) / 10}% </div>
      </div>
      <div className={styles.percentageBar}>
        <div style={{backgroundColor: color, width: percWidth}}/>
      </div>
    </div>
  );
};

const GaugesWidget = observer(() => {
  const { average } = dashboardStore;
  const unitLabel = statUnitLabel(memberStore.app?.platform);
  return (
    <div>
      <div className={styles.chartTitle}> Affected {unitLabel}:</div>
      <div className={styles.gauges}>
        <Percentage src={blackFlag} title="Exception" percentage={average.exception} color="#000000" />
        <Percentage src={wheel} title="Error" percentage={average.error} color="#e51a41" />
        <Percentage src={buoy} title="Warning" percentage={average.warning} color="#ff7336" />
      </div>
    </div>
  );
});

export default GaugesWidget;
